import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared shell for legal pages : consistent dark theme, prose styling,
 * eyebrow + title + last-update badge.
 */
export default function LegalShell({ eyebrow, title, lastUpdate, testid, children }) {
  return (
    <div className="bg-[var(--mc-navy-950)] min-h-screen" data-testid={testid}>
      <section className="hex-grid pt-32 pb-12 lg:pt-40 lg:pb-14">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          {eyebrow && (
            <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#0284C7]">
              <span className="h-px w-7 bg-[var(--mc-blue-400)]" />
              {eyebrow}
            </div>
          )}
          <h1 className="mt-4 font-display text-white text-4xl sm:text-5xl font-semibold leading-[1.1]">
            {title}
          </h1>
          {lastUpdate && (
            <p className="mt-4 text-[12px] text-[var(--mc-muted)]">
              Dernière mise à jour&nbsp;: <span className="text-white/80">{lastUpdate}</span>
            </p>
          )}
        </div>
      </section>

      <section className="hex-soft py-12 lg:py-16">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <article className="legal-prose text-[14.5px] text-white/85 leading-relaxed">
            {children}
          </article>

          <div className="mt-14 pt-8 border-t border-[rgba(127,179,255,0.14)] flex items-center justify-between flex-wrap gap-3 text-[12px] text-[var(--mc-muted)]">
            <Link to="/" className="link-underline text-[#0284C7]">← Retour à l'accueil</Link>
            <a href="mailto:contact@metaconnect.fr" className="link-underline text-[#0284C7]">
              contact@metaconnect.fr
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
